module.exports = __webpack_public_path__ + "img/cash-money.cffde36b.svg";